import React from 'react'
import { useSession } from '@emerald-works/react-auth'
import { Box, Card } from '@mui/material'
import { useStyles } from './styles'
import { useTenant } from '@emerald-works-nova/auth'
import consts from '../../consts'
import { SubscribeToNewsletterForm } from '../newsletter-form'

const NewsletterCTA = () => {
  const classes = useStyles()
  const { isAuthenticated } = useSession()
  const tenant = useTenant()

  const isBrowserUser = !isAuthenticated
  const isClubTenant = tenant.pk === consts.DEFAULT_CLUB_PK

  if (!isBrowserUser || !isClubTenant) return null

  return (
    <Box className={classes.edge}>
      <Card className={classes.card}>
        <SubscribeToNewsletterForm
          mode='CARD'
        />
      </Card>
    </Box>
  )
}

export default NewsletterCTA
